
import { Outlet } from 'react-router-dom'
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from './authenticated-sidebar';
import { SiteHeader } from './site-header';

export function AuthenticatedLayout() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:rounded focus:shadow-md focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Skip to content
      </a>
      <SidebarProvider
        className="authenticated-experience auth-shell-bg"
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
          } as React.CSSProperties
        }
      >
        <AppSidebar variant="inset" />
        <SidebarInset className="bg-muted/30">
          <SiteHeader />
          <main id="main-content" className="flex flex-1 flex-col px-2 pb-2 md:px-3 md:pb-3">
            <div className="@container/main flex flex-1 flex-col gap-3">
              <div className="auth-page-wrap">
                <Outlet />
              </div>
            </div>
          </main>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
}
